import { SettingConst } from '@faire/web-api--source/types';

/**
 * The client facing setting for cart redesign
 * See: https://www.notion.so/faire/Cart-Redesign-24e2efb5c25a80d19f53db5e66279fbe
 * See: https://dev.faire.team/tools/mission-control/mcp_yunhd2r26e
 */
export const CART_REDESIGN_250918 = 'CART_REDESIGN_250918' as SettingConst<
  'CART_REDESIGN_250918',
  boolean,
  'RETAILER' | 'RETAILER_MIDDLEWARE' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
>;
